/* DeadStock "Drops + FOC" behaviour: FOC countdowns, drop slider, tabs. */
(function () {
  var pad = function (n) { return String(n).padStart(2, '0'); };

  // ---- FOC countdowns -------------------------------------------------------
  // <el data-dsd-countdown="2026-10-25T00:00:00-0600" data-format="blocks|pill">
  function parseDeadline(s) {
    if (!s) return null;
    // Safari wants -06:00 rather than -0600
    var d = new Date(s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
    return isNaN(d) ? null : d;
  }
  function tickCountdowns() {
    document.querySelectorAll('[data-dsd-countdown]').forEach(function (el) {
      var end = parseDeadline(el.getAttribute('data-dsd-countdown'));
      if (!end) return;
      var s = Math.max(0, Math.floor((end - new Date()) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      if (s === 0) {
        // The deadline passed while the page was open. The next page load picks the next FOC automatically.
        el.innerHTML = el.getAttribute('data-format') === 'pill' ? 'Next FOC loading…' : '<div class="dsd-cd-done">Closed. Refresh for the next FOC</div>';
        return;
      }
      if (el.getAttribute('data-format') === 'pill') {
        el.textContent = d + 'D ' + pad(h) + ':' + pad(m) + ':' + pad(sec);
      } else {
        el.innerHTML = [[d, 'Days'], [h, 'Hrs'], [m, 'Min'], [sec, 'Sec']].map(function (p) {
          return '<div>' + pad(p[0]) + '<span>' + p[1] + '</span></div>';
        }).join('');
      }
    });
  }

  // ---- drop slider ----------------------------------------------------------
  function initSlider(root) {
    var track = root.querySelector('[data-dsd-track]');
    var slides = root.querySelectorAll('[data-dsd-slide]');
    var dots = root.querySelectorAll('[data-dsd-dot]');
    var bg = root.querySelector('[data-dsd-bg]');
    if (!track || slides.length === 0) return;
    var cur = 0, timer = null, delay = (parseInt(root.getAttribute('data-delay'), 10) || 6) * 1000;
    function go(n) {
      cur = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      if (bg) bg.style.backgroundImage = 'url("' + slides[cur].getAttribute('data-bg') + '")';
      dots.forEach(function (d, i) { d.classList.remove('is-on'); void d.offsetWidth; d.classList.toggle('is-on', i === cur); });
      clearTimeout(timer);
      if (slides.length > 1) timer = setTimeout(function () { go(cur + 1); }, delay);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    root.addEventListener('mouseenter', function () { clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { go(cur); });
    go(0);
  }

  // ---- tabs (optionally lazy-loaded through the Section Rendering API) -------
  function initTabs(root) {
    var buttons = root.querySelectorAll('[data-dsd-tab]');
    var panels = root.querySelectorAll('[data-dsd-panel]');
    var link = root.querySelector('[data-dsd-tab-link]');
    function show(id) {
      buttons.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-dsd-tab') === id); });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-dsd-panel') === id;
        p.hidden = !on;
        if (on && p.hasAttribute('data-src') && !p.dataset.loaded) loadPanel(p);
      });
      var b = root.querySelector('[data-dsd-tab="' + id + '"]');
      if (link && b) { var u = b.getAttribute('data-url'); link.hidden = !u; if (u) link.href = u; link.textContent = b.getAttribute('data-more'); }
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-dsd-tab')); }); });
    if (buttons[0]) show(buttons[0].getAttribute('data-dsd-tab'));
  }
  function loadPanel(p) {
    p.dataset.loaded = '1';
    fetch(p.getAttribute('data-src'))
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-dsd-feed]');
        if (grid && grid.children.length) p.innerHTML = grid.outerHTML;
      })
      .catch(function () { /* keep the server-rendered fallback */ });
  }

  // ---- filter labels: FOC dates / release months are stored as 2026-10-26 / 2026-12 so they sort right ----
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function prettyLabels() {
    document.querySelectorAll('facet-filters-form, .facets, .active-facets, .mobile-facets, .facets-container').forEach(function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (!/20\d\d-\d\d/.test(t)) continue;
        node.nodeValue = t
          .replace(/\b(20\d\d)-(\d\d)-(\d\d)\b/g, function (_, y, m, d) {
            var dt = new Date(+y, m - 1, +d);
            return 'FOC ' + DAY[dt.getDay()] + ' ' + MON[m - 1] + ' ' + (+d);
          })
          .replace(/\b(20\d\d)-(\d\d)\b(?!-)/g, function (_, y, m) { return MON[m - 1] + ' ' + y; });
      }
    });
  }
  // ---- vendor line: the store name isn't the publisher, so never show it as one ------------------------
  var STORE_VENDORS = ['deadstock products', 'my store'];
  function hideStoreVendor() {
    document.querySelectorAll('.card__information .caption-with-letter-spacing, .card-information .caption-with-letter-spacing, .product__text.caption-with-letter-spacing').forEach(function (el) {
      if (STORE_VENDORS.indexOf(el.textContent.trim().toLowerCase()) !== -1) el.style.display = 'none';
    });
  }

  var labelTimer = null;
  new MutationObserver(function () { clearTimeout(labelTimer); labelTimer = setTimeout(function () { prettyLabels(); hideStoreVendor(); }, 40); })
    .observe(document.documentElement, { childList: true, subtree: true });

  function init(scope) {
    (scope || document).querySelectorAll('[data-dsd-slider]').forEach(initSlider);
    (scope || document).querySelectorAll('[data-dsd-tabs]').forEach(initTabs);
    tickCountdowns();
    prettyLabels();
    hideStoreVendor();
  }
  document.addEventListener('DOMContentLoaded', function () { init(); setInterval(tickCountdowns, 1000); });
  // re-init when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
